export class DriveScheduleRestRow {
    etas_eid:string = "";
    drv_kotsa_driver_id:string = "";
    company_nm:string = "";
    user_birth_dt:string = "";
    user_nm:string = "";
    user_hire_dt:string = "";
    dtg_reg_dt:string = "";
    dtg_reg_dt_from:string = "";
    dtg_reg_dt_to:string = "";
    dtg_car_type_nm:string = "";
    restList: [];

    constructor(obj){
        Object.assign(this, obj)
    }
    getTxtDrive(idxCnt:number = 0){
        let txt = "";
        if(this.restList){
            let itemTrip = this.restList[idxCnt];
            if(itemTrip){
                let txtFromTrip = itemTrip["drive_dt_from"];
                let txtToTrip = itemTrip["drive_dt_to"];
                txt = `${txtFromTrip} - ${txtToTrip}`;
            }
        }
        return txt;
    }
    getTxtRest(idxCnt:number = 0){
        let txt = "";
        if(this.restList){
            let itemTrip = this.restList[idxCnt];
            if(itemTrip){
                let txtFromTrip = itemTrip["rest_dt_from"];
                let txtToTrip = itemTrip["rest_dt_to"];
                txt = `${txtFromTrip} - ${txtToTrip}`;
            }
        }
        return txt;
    }
    getDriveTime(idxCnt:number = 0){
        let dur = 0;
        if(this.restList){
            let itemTrip = this.restList[idxCnt];
            if(itemTrip){
                dur = itemTrip["driveTime"];
            }
        }
        return dur;
    }
    getRestTime(idxCnt:number = 0){
        let dur = 0;
        if(this.restList){
            let itemTrip = this.restList[idxCnt];
            if(itemTrip){
                dur = itemTrip["restTime"];
            }
        }
        return dur;
    }    
}